const FREE_CREDIT_RATNA_NOTIF_TYPE = 'freeCreditRatnas';
const POST_TRACKING_NOTIF_TYPE = 'postTracking';
const USAGE_RIGHT_NOTIF_TYPE = 'usageRight';
const ENRICH_LIST_NOTIF_TYPE = 'enrichList';
const LOG_POST_NOTIF_TYPE = 'logPost';
const EMAIL_DISCONNECT_NOTIF_TYPE = 'emailDisconnect';
const TASK_NOTIF_TYPE = 'task';
const PACKAGE_NOTIF_TYPE = 'package';
const ADDRESS_SAVED_NOTIF_TYPE = 'addressSaved';
const DEMOGRAPHICS_NOTIF_TYPE = 'demographics';
const REACHOUT_LIMIT_NOTIF_TYPE = 'reachoutLimit';
const EMAIL_ACCOUNT_UPDATE_FAILURE_NOTIF_TYPE = 'emailAccountUpdateFailure';
const AUTOMATED_SHIPMENT_COMPLETED_NOTIF_TYPE = 'automationShipmentCompleted';
const BULK_UPDATE_COUPON_NOTIF_TYPE = 'bulkUpdateCoupon';
const AUTOMATED_PAYMENT_COMPLETED_NOTIF_TYPE = 'automatedPaymentSuccess';
const AUTOMATED_PAYMENT_FAILED_NOTIF_TYPE = 'automatedPaymentFailed';
const CONTENT_SUBMITTED_NOTIF_TYPE = 'contentSubmitted';
const CONTENT_SUBMISSION_FEEDBACK_ADDED_NOTIF_TYPE = 'contentSubmissionFeedbackAdded';
const CONTENT_SUBMISSION_APPROVED_NOTIF_TYPE = 'contentSubmissionApproved';
const BULK_ORDER_PROCESSING_FAILURE = 'bulkOrderProcessingFailure';

export {
  FREE_CREDIT_RATNA_NOTIF_TYPE,
  POST_TRACKING_NOTIF_TYPE,
  USAGE_RIGHT_NOTIF_TYPE,
  ENRICH_LIST_NOTIF_TYPE,
  LOG_POST_NOTIF_TYPE,
  EMAIL_DISCONNECT_NOTIF_TYPE,
  TASK_NOTIF_TYPE,
  PACKAGE_NOTIF_TYPE,
  ADDRESS_SAVED_NOTIF_TYPE,
  DEMOGRAPHICS_NOTIF_TYPE,
  REACHOUT_LIMIT_NOTIF_TYPE,
  EMAIL_ACCOUNT_UPDATE_FAILURE_NOTIF_TYPE,
  AUTOMATED_SHIPMENT_COMPLETED_NOTIF_TYPE,
  BULK_UPDATE_COUPON_NOTIF_TYPE,
  AUTOMATED_PAYMENT_COMPLETED_NOTIF_TYPE,
  AUTOMATED_PAYMENT_FAILED_NOTIF_TYPE,
  CONTENT_SUBMITTED_NOTIF_TYPE,
  CONTENT_SUBMISSION_FEEDBACK_ADDED_NOTIF_TYPE,
  CONTENT_SUBMISSION_APPROVED_NOTIF_TYPE,
  BULK_ORDER_PROCESSING_FAILURE,
};
